import { render } from "./GroupSchedule.vue?vue&type=template&id=9e185860"
import script from "./GroupSchedule.vue?vue&type=script&lang=js"
export * from "./GroupSchedule.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__